export default __webpack_public_path__ + "static/media/exitDark.fc1e1390.svg";